// Initials on the account page's race bib.
//
//   <div data-member-initials="Jamie Rivers">G.</div>
//
// Swaps in up to two initials from the member's name (or the first
// letter of their email). The template's text stays if JS is off.

export default function memberInitials() {
    const el = document.querySelector("[data-member-initials]");
    if (!el) return;

    const source = (el.dataset.memberInitials || "").split("@")[0].trim();
    const initials = source
        .split(/[\s._-]+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0].toUpperCase())
        .join("");

    if (initials) el.textContent = initials;
}
